/**
 * Quick Add — triggered from any [data-quick-add-trigger] button (product
 * cards on homepage / collection / related rails). Fetches the product's
 * public JSON (no section round trip needed), renders variant pills into
 * the shared modal shell, and adds to cart via WallZ.Cart.addItem so the
 * drawer + header bubble stay in sync with the rest of the theme.
 */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function openModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('no-scroll');
  }
  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
  }

  function renderProduct(product, content) {
    var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var selected = variant.options.slice();

    function findVariant() {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
    }

    var optionsHtml = product.options.map(function (name, index) {
      var values = Array.from(new Set(product.variants.map(function (v) { return v.options[index]; })));
      var pills = values.map(function (val) {
        return '<button type="button" class="option-pill' + (val === selected[index] ? ' is-selected' : '') + '" data-qa-option-value="' + val + '" data-qa-option-index="' + index + '">' + val + '</button>';
      }).join('');
      return '<div class="option-selector" data-qa-option-index="' + index + '"><label class="field-label">' + name + '</label><div class="option-selector__pills">' + pills + '</div></div>';
    }).join('');

    content.innerHTML =
      '<div class="quick-add-modal__product">' +
        (product.featured_image ? '<img src="' + product.featured_image + '&width=200" alt="">' : '') +
        '<div><p class="quick-add-modal__title">' + product.title + '</p><p class="quick-add-modal__price" data-qa-price>' + WallZ.utils.formatMoney(variant.price) + '</p></div>' +
      '</div>' +
      (product.options.length > 1 || product.options[0] !== 'Title' ? optionsHtml : '') +
      '<button type="button" class="btn btn--accent btn--full btn--lg" data-qa-add' + (variant.available ? '' : ' disabled') + '>' +
        '<span class="btn-spinner"></span><span class="btn-label">' + (variant.available ? window.WallZ.strings.addToCart : window.WallZ.strings.soldOut) + '</span>' +
      '</button>' +
      '<a href="' + product.url + '" class="btn btn--ghost btn--full" style="margin-top:10px;">View full details</a>';

    content.querySelectorAll('.option-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var index = parseInt(pill.dataset.qaOptionIndex, 10);
        var group = pill.closest('.option-selector');
        group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        selected[index] = pill.dataset.qaOptionValue;
        var v = findVariant();
        var addBtn = content.querySelector('[data-qa-add]');
        var priceEl = content.querySelector('[data-qa-price]');
        if (v) {
          priceEl.textContent = WallZ.utils.formatMoney(v.price);
          addBtn.disabled = !v.available;
          addBtn.querySelector('.btn-label').textContent = v.available ? window.WallZ.strings.addToCart : window.WallZ.strings.soldOut;
        }
      });
    });

    var addBtn = content.querySelector('[data-qa-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var v = findVariant();
        if (!v) return;
        addBtn.classList.add('is-loading');
        WallZ.Cart.addItem(v.id, 1).then(function () {
          addBtn.classList.remove('is-loading');
          var modal = content.closest('[data-quick-add-modal]');
          if (modal) closeModal(modal);
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = $('[data-quick-add-modal]');
    if (!modal) return;
    var content = $('[data-quick-add-content]', modal);

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (!trigger) return;
      e.preventDefault();
      content.innerHTML = '<div class="skeleton" style="height:320px;border-radius:var(--radius);"></div>';
      openModal(modal);
      fetch('/products/' + trigger.dataset.productHandle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) { renderProduct(product, content); })
        .catch(function () { content.innerHTML = '<p>Sorry, this product could not be loaded.</p>'; });
    });

    modal.querySelectorAll('[data-quick-add-close]').forEach(function (btn) { btn.addEventListener('click', function () { closeModal(modal); }); });
    var overlay = $('[data-overlay]');
    if (overlay) overlay.addEventListener('click', function () { if (modal.classList.contains('is-open')) closeModal(modal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(modal); });
  });
})();
